export default __webpack_public_path__ + "static/media/logo.0ddb3d9a.svg";